import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import usePrevious from 'hooks/usePrevious';
import { hideModal } from 'redux/modules/modal';
import { PostStatus } from 'redux/modules/social/constants';
import { Dispatch } from 'redux/types';
import { useSocialShareModal } from '../SocialShareModalContext';
import { useSocialSharePlatform } from './SocialSharePlatformContext';

export type UseSocialPostShareStatusConfig = {
  onSuccess?: () => void;
  onError?: () => void;
};

export type UseSocialPostShareStatusResult = {
  isSharingPost: boolean;
};

export default function useSocialPostShareStatus({
  onSuccess,
  onError,
}: UseSocialPostShareStatusConfig = {}): UseSocialPostShareStatusResult {
  const { postStatus } = useSocialSharePlatform();
  const { resetDescription } = useSocialShareModal();

  const prevPostStatus = usePrevious(postStatus);

  const dispatch = useDispatch<Dispatch>();

  const isPrevSharingPost = prevPostStatus === PostStatus.IN_PROGRESS;

  useEffect(() => {
    if (isPrevSharingPost && postStatus === PostStatus.SUCCESS) {
      resetDescription();
      dispatch(hideModal());
      onSuccess?.();

      return;
    }

    if (isPrevSharingPost && postStatus === PostStatus.FAILURE) {
      dispatch(hideModal());
      onError?.();
    }
  }, [
    dispatch,
    isPrevSharingPost,
    onError,
    onSuccess,
    postStatus,
    resetDescription,
  ]);

  return {
    isSharingPost: postStatus === PostStatus.IN_PROGRESS,
  };
}
